import { QueryClient } from "react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 60 * 24, // 1 day
      cacheTime: 1000 * 60 * 60 * 24, // 1 day
    },
  },
});
